<template>
  <span class="safe-chat-text"><span v-for="(part, index) in parts" :key="index" :class="{ 'safe-chat-text__match': part.highlight }">{{ part.text }}</span></span>
</template>
<script>
import { splitHighlightedText } from '@/utils/chat-text'
export default {
  name: 'SafeChatText',
  props: {
    text: { default: '' },
    keyword: { type: String, default: '' }
  },
  computed: {
    parts() { return splitHighlightedText(this.text, this.keyword) }
  }
}
</script>
<style scoped>
.safe-chat-text { white-space: pre-wrap; overflow-wrap: break-word; }
.safe-chat-text__match { color: #e50011; background: rgba(228, 255, 4, .4); }
</style>
